import React from 'react'
import { getLrc20SendTx } from '../../util/new-api';
import { getBtcUtxos } from '../../util/ordinal';
import { postUnisatTransaction } from '../../util/api';
import { prepareSrc20Wallet } from '../../util/stamp-api';
import { getFeeRate, bytesToHex, buf2hex, textToHex, hexToBytes, getMempoolUtxos, loopTilAddressReceivesMoney, waitSomeSeconds, addressReceivedMoneyInThisTx, pushBTCpmt, calculateFeeReal, getData, isValidTaprootAddress} from '../../util/inscribe-util';
import { encodedAddressPrefix, tippingAddress, ownerAddress, royalty, tip, contentLength, serviceFeeRate, padding } from '../../configs/constant';
import SolanaConnect from '../../components/SolanaConnect';
import { useSelector } from 'react-redux';
import { payWithSolflareWallet, payWithMagicEdenWallet } from '../../util/solana-api';
import { bitcoinsdk } from "bitcoinsdk/core";
import { saveBrc20ClaimData, getBrc20ClaimData, getAllBrc20ClaimData, updateBrc20ClaimData } from '../../util/brc20-api';
import { registerReferalCode, registerReferalHistory, getReferalHistory } from '../../util/refer-api';
import DoubleProgressBar from '../../components/ProgressBar/DoubleProgressBar';
import { saveOp20TradeData, splitPsbt } from '../../util/op20-api';
import { useTranslation } from 'react-i18next';
import { useWallets } from '@wallet-standard/react';

export default function Test() {
  const { Address, Script, Signer, Tap, Tx } = window.tapscript;
  const solanaWallet = useSelector(state => state.solanaWallet);
  const { wallets } = useWallets();
  const { t, i18n } = useTranslation();

  const SatsConnectNamespace = 'sats-connect:';

  const isSatsConnectCompatibleWallet = (wallet) => {
      return SatsConnectNamespace in wallet.features;
  }

  const wallet = useSelector(state => state.wallet);

  const handleClick = async () => {
    if (!typeof window) return
    if (!window.tapscript) return

    let cryptoUtils = window.cryptoUtils;
    const KeyPair = cryptoUtils.KeyPair;

    //let privkey = bytesToHex(cryptoUtils.Noble.utils.randomPrivateKey());
    let privkey = "df85718a28a1f5887ea62482567078a75755efb2d6b650f13064e2cb53fa0b60";
    console.log("--privkey---", privkey);

    let seckey = new KeyPair(privkey);
    let pubkey = seckey.pub.rawX;

    const ec = new TextEncoder();

    const init_script = [
      pubkey,
      'OP_CHECKSIG'
    ];
    
    const init_script_backup = [
        '0x' + buf2hex(pubkey.buffer),
        'OP_CHECKSIG'
    ];

    let init_leaf = await Tap.tree.getLeaf(Script.encode(init_script));
    let [init_tapkey, init_cblock] = await Tap.getPubKey(pubkey, {target: init_leaf});

    const test_redeemtx = Tx.create({
      vin  : [{
          txid: 'a99d1112bcb35845fd44e703ef2c611f0360dd2bb28927625dbc13eab58cd968',
          vout: 0,
          prevout: {
              value: 10000,
              scriptPubKey: [ 'OP_1', init_tapkey ]
          },
      }],
      vout : [{
          value: 8000,
          scriptPubKey: [ 'OP_1', init_tapkey ]
      }],
    });
    
    const test_sig = await Signer.taproot.sign(seckey.raw, test_redeemtx, 0, {extension: init_leaf});
    test_redeemtx.vin[0].witness = [ test_sig.hex, init_script, init_cblock ];
    const isValid = await Signer.taproot.verify(test_redeemtx, 0, { pubkey });

    if(!isValid)
    {
      alert('Generated keys could not be validated. Please reload the app.');
      return;
    }

    let files = [];

    let mimetype = "text/plain;charset=utf-8";
    let salts = "";
    let tickerPubKey = "";

    let text = "5120569efa2c50b797dd545ceb685fa8aeb055cf4c28e8e103ea9dcd132a27487d66a13f0000030000009d1860417036ea0db8bd09c09ed77c10ed6b4ee71e6dff493e94be9a3cf82bbfc57d71232be3366fc0d268fa15fb8c98b738ae545265ceb75db61548a809d84c55e796a7937dce55da597d26e32fd36f9679ab5b30be916b8a3ca29c2074effc568ba3b9b3442fd10d561a2c2c3278f0b0ca1f2a70e68da2a39b9841a7c83d51d7004573cd446591e23ca80d106ffeae20def7133be76abd990e3414f7960cad2f452fe162b64903bb83155785fdad32e1de048f0ec7cbe8a2b194175fe143f77cfe6c1c6d0acdec528a68e2020d04b651a9f0aff7ce383cf45eb962c8e5a47145640563e25b4b88b033eb6d95354581ecdd30b5c903303da78aa1516db091d74658f8506039f4b064456d5315d1af8e66316271e2f14d19dc4b7cfb7dba003a";
    for(let i = 0; i< 1; i++)
    {
      files.push({
        name: text,
        hex: text,
        mimetype: mimetype,
        sha256: ''
      });
    }

    let inscriptions = [];
    let inscriptionAddressList = [];

    let recipientList = [];

    for (let i = 0; i < files.length; i++) {

      const hex = files[i].hex;
      const data = hexToBytes(hex);
      const mimetype = ec.encode(files[i].mimetype);
      const tag = hexToBytes('d201');
      console.log("--encode---", ec.encode('BIN'));

      const script = [
          pubkey,
          'OP_CHECKSIG',
          'OP_0',
          'OP_IF',
          ec.encode('BIN'),
          tag,
          data,
          'OP_ENDIF'
      ];

      const leaf = await Tap.tree.getLeaf(Script.encode(script));
      const [tapkey, cblock] = await Tap.getPubKey(pubkey, { target: leaf });

      let inscriptionAddress = Address.p2tr.encode(tapkey, encodedAddressPrefix);

      let prefix = 160;

      let txsize = prefix + Math.floor(data.length / 4);

      inscriptionAddressList.push(inscriptionAddress);
      inscriptions.push(
        {
          leaf: leaf,
          tapkey: tapkey,
          cblock: cblock,
          inscriptionAddress: inscriptionAddress,
          txsize: txsize,
          script_orig: script
        }
      );
    }


    console.log(inscriptionAddressList);
    await inscribe(inscriptions[0], 0, "98289451413d18616443e2523a8c17113c616cde42685c82308660e7ea1446bb", 1800, seckey);
  }
  
  const inscribe = async(inscription, vout, txid2, amt2, seckey) => {
    let _toAddress;
    let _script;
    let toAddress = "bc1p26005tzsk7ta64zuad59l29wkp2u7npgarss865ae5fj5f6g04nq5jxkpz";
    if(toAddress.startsWith('tb1q') || toAddress.startsWith('bc1q'))
    {
        _toAddress = Address.p2wpkh.decode(toAddress, encodedAddressPrefix).hex;
        _script = [ 'OP_0', _toAddress ];
    }
    else if(toAddress.startsWith('1') || toAddress.startsWith('m') || toAddress.startsWith('n'))
    {
        _toAddress = Address.p2pkh.decode(toAddress, encodedAddressPrefix).hex;
        _script = Address.p2pkh.scriptPubKey(_toAddress);
    }
    else if(toAddress.startsWith('3') || toAddress.startsWith('2'))
    {
        _toAddress = Address.p2sh.decode(toAddress, encodedAddressPrefix).hex;
        _script = Address.p2sh.scriptPubKey(_toAddress);
    }
    else
    {
        _toAddress = Address.p2tr.decode(toAddress, encodedAddressPrefix).hex;
        _script = [ 'OP_1', _toAddress ];
    }

    const redeemtx = Tx.create({
        vin  : [{
            txid: txid2,
            vout: vout,
            prevout: {
                value: amt2,
                scriptPubKey: [ 'OP_1', inscription.tapkey ]
            },
        }],
        vout : [
        {
          value: 1000,
          scriptPubKey: _script
        },
        {
          value: 0,
          scriptPubKey: ["OP_RETURN", "OP_13", "ff7f818cec82d08bc0a882e1aefe88bc02"]
        }
      ],
    });

    const sig = await Signer.taproot.sign(seckey.raw, redeemtx, 0, {extension: inscription.leaf});
    redeemtx.vin[0].witness = [ sig.hex, inscription.script_orig, inscription.cblock ];

    console.dir(redeemtx, {depth: null});

    let rawtx2 = Tx.encode(redeemtx).hex;
    let _txid2;

    _txid2 = await pushBTCpmt( rawtx2 );
    await waitSomeSeconds(2);

  }

  return (
    <div className = "mt-[80px] text-white flex flex-col gap-4">
      <button onClick={handleClick}>Handle Test</button>
    </div>
  )
}
